import { Request } from './Request';

export let UpdateStringServerSettingNames = {
  defaultLanguage:            'defaultLanguage',
  defaultLocale:              'defaultLocale',
  signInNoteText:             'signInNoteText',
  signInNoteUrl:              'signInNoteUrl'
};

export interface IUpdateStringServerSettingParams {
  setting: string;
  value: string;
}

export interface IUpdateStringServerSettingResult {
}

export class UpdateStringServerSettingRequest extends Request<IUpdateStringServerSettingParams, IUpdateStringServerSettingResult> {
  constructor(params: IUpdateStringServerSettingParams) {
    super('updateStringServerSetting', params);
  }
}
